import React from "react";
import "./Bid.css";
import { Card, Col, Container, Row } from "react-bootstrap";
import {
  BidDeposit_Info,
  BidDeposit_Info_Selected_Bidder,
  BidDeposit_Info_Required,
} from "@/setting";
function BidDepositInfo(data) {
  // console.log("data", data);
  const cmsData = data?.data;
  return (
    <>
      <Container fluid className="px-0">
        <Row>
          <Col xs={12}>
            <Card className="p-3 bid-deposit-card">
              <Card.Body>
                <div className="mb-2 bid-deposit-title-info">
                  Important Bid Deposit Information
                </div>
                <Card.Text className="bid-deposit-text-info">
                  {cmsData?.BidDeposit_Info || BidDeposit_Info}{" "}
                  <span className="bid_bold">
                    {cmsData?.BidDeposit_Info_Selected_Bidder ||
                      BidDeposit_Info_Selected_Bidder}
                  </span>
                </Card.Text>
                <Card.Text className="bid-deposit-text-info mb-0">
                  {cmsData?.BidDeposit_Info_Required ||
                    BidDeposit_Info_Required}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default BidDepositInfo;
